/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface CollectionSplashHeroUiModuleBody
 */
export interface CollectionSplashHeroUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof CollectionSplashHeroUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionSplashHeroUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionSplashHeroUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof CollectionSplashHeroUiModuleBody
     */
    moduleType: CollectionSplashHeroUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof CollectionSplashHeroUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof CollectionSplashHeroUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof CollectionSplashHeroUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof CollectionSplashHeroUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof CollectionSplashHeroUiModuleBody
     */
    title: LocalizedFieldBody;
    /**
     * 
     * @type {string}
     * @memberof CollectionSplashHeroUiModuleBody
     */
    collectionId: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CollectionSplashHeroUiModuleBodyModuleTypeEnum {
    COLLECTION_SPLASH_HERO = 'COLLECTION_SPLASH_HERO'
}



